var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTotalCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "url(#paint0_linear_36_292)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 30C37.6421 30 41 28.8807 41 27.5C41 26.1193 37.6421 25 33.5 25C29.3579 25 26 26.1193 26 27.5C26 28.8807 29.3579 30 33.5 30Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 33C41 34.66 37.6667 36 33.5 36C29.3333 36 26 34.66 26 33",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27V39.3529C26 40.8176 29.3333 42 33.5 42C37.6667 42 41 40.8176 41 39.3529V27",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_292",
    x1: 0,
    y1: 34,
    x2: 68,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4348E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7679DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalCost);
export default __webpack_public_path__ + "static/media/Icon-total-cost.51e2bc9693ad152d667c8aa1db9aa1da.svg";
export { ForwardRef as ReactComponent };